import { gsap } from "gsap/all";
import { supportsPassiveEvents } from 'detect-it';
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Accordion from 'accordion-js';
import Recommendations from './recommendations';
import InteractableModals from './interactableModals';
import Carousel from './carousel';
import Draggable from './draggable';
import MovingElements from './movingElements';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
import { SVG } from '@svgdotjs/svg.js';
import { throttle } from 'lodash';
// window['SVG'] = SVG;
// import '../lib/svg.math.js/svg.math.min.js';

class Courses {
	constructor () {
		this.init = this.init.bind(this);
		this.recommendationListeners = this.recommendationListeners.bind(this);
		this.drawLines = this.drawLines.bind(this);
		this.listenScroll = this.listenScroll.bind(this);
		this.scrollCallback = this.scrollCallback.bind(this);

		this.lines = [];
	}

	init () {
		console.log('Init Course');

		this.recommendationListeners();
		this.wavy();
		this.listenScroll();
		this.parallax();

		const carou = new Carousel();
		carou.init();

		this.expandableAttractions();

		setTimeout(() => {
			this.drawLines();
		}, 2000);

		const movingTop = new MovingElements({
			elements: document.body.querySelectorAll('.attraction-list-image-container'),
	    clipBox: {width: 400, height: 400},
			container: document.body.querySelector('.accordion-container'),
	    fullscreen: false,
			matchMedia: '(pointer: fine) and (min-width: 768px)'
		});
		movingTop.init();
	}

	drawLines () {
		const images = document.body.querySelectorAll('.attraction-list-image-container');

		const mq = window.matchMedia("(min-width: 768px)");
		if (!mq.matches || !images || !images.length) {
			return;
		}

		const svgContainer = document.body.querySelector('.svg-container');
		const draw = SVG().addTo(svgContainer).size(svgContainer.offsetWidth, svgContainer.offsetHeight);
		const imgSize = images[0].offsetHeight / 2;
		// console.log(imgSize, images);

		for (var i = 0; i < images.length - 1; i++) {
			// const ml = new SVG().math.Line({x:images[i].offsetLeft + imgSize, y: images[i].offsetTop + imgSize}, {x: images[i + 1].offsetLeft + imgSize, y: images[i + 1].offsetTop + imgSize});
			const line = draw.line(images[i].offsetLeft + imgSize, (images[i].offsetTop + images[i].closest('.course-attractions-list').offsetTop) + imgSize, images[i + 1].offsetLeft + imgSize, (images[i + 1].offsetTop + images[i + 1].closest('.course-attractions-list').offsetTop) + imgSize).stroke({ width: 1 }).animate();

			// console.log({i: i, image: images[i], y: images[i].offsetTop + images[i].closest('.course-attractions-list').offsetTop});

			// const line = draw.path([[0,0], [150,50], [200,50]]);
			line.stroke({ color: '#D0BFAE' });

			this.lines.push({line, x1: images[i].offsetLeft + imgSize, y1: (images[i].offsetTop + images[i].closest('.course-attractions-list').offsetTop) + imgSize, x2: images[i + 1].offsetLeft + imgSize, y2: (images[i + 1].offsetTop + images[i + 1].closest('.course-attractions-list').offsetTop) + imgSize});
		}
	}

	expandableAttractions () {
		const mq = window.matchMedia("(max-width: 767px)");
		if (!mq.matches) {
			console.warn('Mediaquery not matching. Skipping accordion.');
			return;
		}

		const cont = document.body.querySelector('.accordion-container');
		const acc = new Accordion(cont, {
			onOpen: function(currentElement) {
		    console.log({currentElement});
				const to = currentElement.getBoundingClientRect().top + window.scrollY - 20;

				console.log({to});

				gsap.to(window, {duration: 0.4, scrollTo: to});
		  }
		});
	}

	recommendationListeners () {
		const btns = document.body.querySelectorAll('#action-recommend');

		const recommendations = new Recommendations();
 		btns.forEach((btn, i) => {
 			btn.addEventListener('click', recommendations.chechRecommendStatus);
 		});
	}

	parallax () {
		console.log('Parallax');

		ScrollTrigger.matchMedia({
			"(min-width: 200px) and (max-width: 767px)": function () {
				gsap.to('.scroll-trigger-top', {
					y: -60,
					scrollTrigger: {
				    trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.top-info', {
					y: -100,
					scrollTrigger: {
				    trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
				gsap.to('.breadcrumb-list', {
					y: -120,
					scrollTrigger: {
						trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
			},
			"(min-width: 768px)": function () {
				gsap.to('.scroll-trigger-top', {
					y: -150,
					scrollTrigger: {
						trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});


				gsap.to('.breadcrumb-list', {
					y: -160,
					scrollTrigger: {
						trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.top-info', {
					y: -100,
					scrollTrigger: {
						trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.top-bottom-info', {
					y: -60,
					scrollTrigger: {
				    trigger: '#attractions-top',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
			}
		});
	}

	wavy () {
		const mq = window.matchMedia("(min-width: 768px)");
		if (!mq.matches) {
			return;
		}

		let landmarkContainers = document.body.querySelectorAll('.landmark-container');
		let textContainers = document.body.querySelectorAll('.text-content-container');

		textContainers.forEach((container, i) => {
 			// x = parseInt(Math.random() * 14);
 			// y = parseInt(Math.random() * 6);
 			gsap.fromTo(container, {y: 50}, {
 				y: 0,
 				// delay: i,
 				// ease: 'back.inOut(1.7)',
 				scrollTrigger: {
 			    trigger: container,
 					// start: 'top top',
 					// end: 'bottom top',
 					scrub: 1,
 				}
 			})
 		});

		landmarkContainers.forEach((container, i) => {
 			// x = parseInt(Math.random() * 14);
 			// y = parseInt(Math.random() * 6);
 			gsap.fromTo(container, {y: -40, opacity: 0.5, scale: 1}, {
 				y: 10,
				opacity: 1,
				scale: 1.2,
 				// delay: i,
 				// ease: 'back.inOut(1.7)',
 				scrollTrigger: {
 			    trigger: container,
 					// start: 'top top',
 					// end: 'bottom top',
 					scrub: 1,
 				}
 			})
 		});

	 	// let images = document.body.querySelectorAll('.attraction-list-image-container');
		// let scrollContainer = document.body.querySelector('#attractions');

 		// var self = this;
 		// var x = 0;
 		// var y = 0;
 		// images.forEach((image, i) => {
 		// 	// x = parseInt(Math.random() * 14);
 		// 	// y = parseInt(Math.random() * 6);
 		// 	gsap.to(image, {
 		// 		y: 15,
 		// 		// delay: i,
 		// 		ease: 'back.inOut(1.7)',
 		// 		scrollTrigger: {
 		// 	    trigger: image,
 		// 			// start: 'top top',
 		// 			// end: 'bottom top',
 		// 			scrub: 1,
 		// 		}
 		// 	})
 		// });

		// let delayedCall;
		// let y;
		// let iY;
		// let iX;
		// ScrollTrigger.create({
	  //   trigger: scrollContainer,
		// 	// start: 'top top',
		// 	// end: 'bottom top',
		// 	// onUpdate: (e) => {
		// 	// 	console.log('update:', e.getVelocity(), e);
		// 	// },
		// 	// onToggle: (e) => {
		// 	// 	// console.log('toggle:', e);
		// 	// }
		//
		// 	onToggle: self => console.log("toggled, isActive:", self.isActive),
		//   onUpdate: self => {
		// 		if (!this.lines.length) return; // wait for the lines
		//
		// 		y = self.getVelocity() / 10;
		//
		// 		console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "y", y);
		//
		// 		let i = 0;
		// 		for (var image of images) {
		// 			iY = -y; // * Math.random();
		// 			iX = 20 * Math.random();
		// 			gsap.to(image, {y: iY, ease: 'power3.easeOut'});
		//
		// 			// if (i < this.lines.length) {
		// 			// 	this.lines[i].line.plot(this.lines[i].x1 + iX, this.lines[i].y1 + iY, this.lines[i].x2 + iX, this.lines[i].y2 + iY);
		// 			// }
		//
		// 			i++;
		// 		}
		//
		// 		if (delayedCall) delayedCall.kill(); // kill the "return-to-home"-animation if its not completed
		//
		//     delayedCall = gsap.delayedCall(0.1, () => gsap.to(images, {y: 0, x: 0, ease: 'elastic.easeOut.config(1.75,0.4)', duration: 0.8}));
		//   }
		// })
	}

	listenScroll () {
		const mq = window.matchMedia("(min-width: 768px)");
		if (!mq.matches) {
			return;
		}

		this.parent = document.querySelector('.courses-sticky-menu-parent');
		this.menu = this.parent.querySelector('.courses-sticky-menu');
		this.menuItemKey = this.menu.querySelector('.key-info');
		this.menuItemAttractions = this.menu.querySelector('.attractions');
		this.menuItemMap = this.menu.querySelector('.map');
		this.keyInfo = document.querySelector('.key-information-anchor');
		this.attractions = document.querySelector('#attractions');
		this.map = document.querySelector('#map-section');

		this.sticky = false;

		const thro = throttle(this.scrollCallback, 50);
		window.addEventListener('scroll', thro, supportsPassiveEvents ? { passive: true, capture: false } : false);
	}

	scrollCallback () {
		const fromTop = this.parent.getBoundingClientRect().top + window.scrollY;

		if (window.pageYOffset > fromTop) {
			if (this.sticky) {
				const keyFromTop = this.keyInfo ? this.keyInfo.getBoundingClientRect().top + window.scrollY - 50 : 0;
				const attractionsFromTop = this.attractions.getBoundingClientRect().top + window.scrollY - 50;
				const mapFromTop = this.map.getBoundingClientRect().top + window.scrollY - 50;
				// console.log({keyFromTop, scrolled: window.pageYOffset});
				// console.log({attractionsFromTop, scrolled: window.pageYOffset});
				// console.log({mapFromTop, scrolled: window.pageYOffset});

				if (window.pageYOffset > keyFromTop && window.pageYOffset < attractionsFromTop) {
					// console.log('KeyInfo active');
					if (this.menuItemKey) {
						this.menuItemKey.classList.add('active');
					}
					this.menuItemAttractions.classList.remove('active');
					this.menuItemMap.classList.remove('active');
				} else if (window.pageYOffset > attractionsFromTop && window.pageYOffset < mapFromTop) {
					// console.log('Attractions active');
					this.menuItemAttractions.classList.add('active');
					if (this.menuItemKey) {
						this.menuItemKey.classList.remove('active');
					}
					this.menuItemMap.classList.remove('active');
				} else if (window.pageYOffset > attractionsFromTop && window.pageYOffset < mapFromTop) {
					// console.log('Map active');
					this.menuItemMap.classList.add('active');
					if (this.menuItemKey) {
						this.menuItemKey.classList.remove('active');
					}
					this.menuItemAttractions.classList.remove('active');
				}
			} else {
				console.log('Make sticky');
				this.sticky = true;
				this.menu.classList.add('sticky');
			}
		} else if (window.pageYOffset < fromTop && this.sticky) {
			console.log('Make UNsticky');
			this.sticky = false;
			this.menu.classList.remove('sticky');
		}
	}
}

export default Courses;
